/**
 * @name CssAnimationTimingFunction
 * @description
 * The timing function of the animation
 * @enum {string}
 * @property {string} EASE_IN - The animation starts slowly and speeds up towards the end
 * @property {string} EASE_OUT - The animation starts quickly and slows down towards the end
 * @property {string} EASE_IN_OUT - The animation starts slowly, speeds up in the middle, and then slows down again towards the end
 * @property {string} EASE - The animation starts slowly, speeds up in the middle, and then slows down again towards the end
 * @property {string} LINEAR - The animation has the same speed from start to end
 */
export var CssAnimationTimingFunction;
(function (CssAnimationTimingFunction) {
    CssAnimationTimingFunction["EASE_IN"] = "ease-in";
    CssAnimationTimingFunction["EASE_OUT"] = "ease-out";
    CssAnimationTimingFunction["EASE_IN_OUT"] = "ease-in-out";
    CssAnimationTimingFunction["EASE"] = "ease";
    CssAnimationTimingFunction["LINEAR"] = "linear";
})(CssAnimationTimingFunction || (CssAnimationTimingFunction = {}));
/**
 * @name CssAnimationExecuteOption
 * @description
 * The execute option of the animation
 */
export var CssAnimationExecuteOption;
(function (CssAnimationExecuteOption) {
    CssAnimationExecuteOption["HIDDEN"] = "HIDDEN";
    CssAnimationExecuteOption["START"] = "START";
    CssAnimationExecuteOption["END"] = "END";
})(CssAnimationExecuteOption || (CssAnimationExecuteOption = {}));
//# sourceMappingURL=cssAnimation.js.map